import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedConnect = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M36.12,72.12c-19.48,0-35.33-15.85-35.33-35.33S16.63,1.46,36.12,1.46s35.33,15.85,35.33,35.33
		S55.6,72.12,36.12,72.12z M36.12,5.06c-17.5,0-31.73,14.23-31.73,31.73s14.23,31.73,31.73,31.73s31.73-14.23,31.73-31.73
		S53.61,5.06,36.12,5.06z"
                />
                <g>
                    <path
                        className={styles.cls1}
                        d="M36.06,47.57c-6.16,0-11.17-5.01-11.17-11.17c0-6.16,5.01-11.17,11.17-11.17c6.16,0,11.17,5.01,11.17,11.17
			C47.23,42.56,42.22,47.57,36.06,47.57z M36.06,27.63c-4.84,0-8.77,3.93-8.77,8.77s3.93,8.77,8.77,8.77s8.77-3.93,8.77-8.77
			S40.89,27.63,36.06,27.63z"
                    />
                    <path
                        className={styles.cls1}
                        d="M36.06,23.1c-2.16,0-3.92-1.76-3.92-3.92s1.76-3.92,3.92-3.92s3.92,1.76,3.92,3.92S38.22,23.1,36.06,23.1z
			 M36.06,17.66c-0.84,0-1.52,0.68-1.52,1.52s0.68,1.52,1.52,1.52s1.52-0.68,1.52-1.52S36.9,17.66,36.06,17.66z"
                    />
                    <path
                        className={styles.cls1}
                        d="M36.06,58.44c-2.16,0-3.92-1.76-3.92-3.92s1.76-3.92,3.92-3.92s3.92,1.76,3.92,3.92S38.22,58.44,36.06,58.44z
			 M36.06,53.01c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52s1.52-0.68,1.52-1.52C37.58,53.69,36.9,53.01,36.06,53.01z"
                    />
                    <path
                        className={styles.cls1}
                        d="M49.65,27.63c-2.16,0-3.92-1.76-3.92-3.92s1.76-3.92,3.92-3.92c2.16,0,3.92,1.76,3.92,3.92
			S51.81,27.63,49.65,27.63z M49.65,22.19c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52c0.84,0,1.52-0.68,1.52-1.52
			C51.17,22.87,50.49,22.19,49.65,22.19z"
                    />
                    <path
                        className={styles.cls1}
                        d="M52.37,40.32c-2.16,0-3.92-1.76-3.92-3.92c0-2.16,1.76-3.92,3.92-3.92s3.92,1.76,3.92,3.92
			C56.29,38.56,54.53,40.32,52.37,40.32z M52.37,34.88c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52
			c0.84,0,1.52-0.68,1.52-1.52C53.89,35.56,53.21,34.88,52.37,34.88z"
                    />
                    <path
                        className={styles.cls1}
                        d="M49.65,53.01c-2.16,0-3.92-1.76-3.92-3.92c0-2.16,1.76-3.92,3.92-3.92c2.16,0,3.92,1.76,3.92,3.92
			C53.57,51.25,51.81,53.01,49.65,53.01z M49.65,47.57c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52
			c0.84,0,1.52-0.68,1.52-1.52C51.17,48.25,50.49,47.57,49.65,47.57z"
                    />
                    <rect
                        x="34.86"
                        y="21.9"
                        className={styles.cls1}
                        width="2.4"
                        height="4.53"
                    />
                    <rect
                        x="34.86"
                        y="46.37"
                        className={styles.cls1}
                        width="2.4"
                        height="5.44"
                    />

                    <rect
                        x="42.37"
                        y="26.59"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -6.3002 40.3654)"
                        className={styles.cls1}
                        width="6.41"
                        height="2.4"
                    />

                    <rect
                        x="44.38"
                        y="41.8"
                        transform="matrix(0.707 -0.7072 0.7072 0.707 -18.4766 45.4174)"
                        className={styles.cls1}
                        width="2.4"
                        height="6.41"
                    />
                    <rect
                        x="46.03"
                        y="35.2"
                        className={styles.cls1}
                        width="3.63"
                        height="2.4"
                    />
                    <path
                        className={styles.cls1}
                        d="M22.46,27.63c-2.16,0-3.92-1.76-3.92-3.92s1.76-3.92,3.92-3.92s3.92,1.76,3.92,3.92S24.62,27.63,22.46,27.63z
			 M22.46,22.19c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52c0.84,0,1.52-0.68,1.52-1.52
			C23.98,22.87,23.3,22.19,22.46,22.19z"
                    />
                    <path
                        className={styles.cls1}
                        d="M19.74,40.32c-2.16,0-3.92-1.76-3.92-3.92c0-2.16,1.76-3.92,3.92-3.92s3.92,1.76,3.92,3.92
			C23.66,38.56,21.9,40.32,19.74,40.32z M19.74,34.88c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52
			c0.84,0,1.52-0.68,1.52-1.52C21.26,35.56,20.58,34.88,19.74,34.88z"
                    />
                    <path
                        className={styles.cls1}
                        d="M22.46,53.01c-2.16,0-3.92-1.76-3.92-3.92c0-2.16,1.76-3.92,3.92-3.92s3.92,1.76,3.92,3.92
			C26.38,51.25,24.62,53.01,22.46,53.01z M22.46,47.57c-0.84,0-1.52,0.68-1.52,1.52c0,0.84,0.68,1.52,1.52,1.52
			c0.84,0,1.52-0.68,1.52-1.52C23.98,48.25,23.3,47.57,22.46,47.57z"
                    />

                    <rect
                        x="25.34"
                        y="24.58"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -11.8748 26.9071)"
                        className={styles.cls1}
                        width="2.4"
                        height="6.41"
                    />

                    <rect
                        x="23.34"
                        y="43.81"
                        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -24.0513 31.9508)"
                        className={styles.cls1}
                        width="6.41"
                        height="2.4"
                    />
                    <rect
                        x="22.46"
                        y="35.2"
                        className={styles.cls1}
                        width="3.63"
                        height="2.4"
                    />
                    <path
                        className={styles.cls1}
                        d="M42.7,44.55h-2.4v-3.12c-0.15-0.53-2.31-2.02-4.24-2.02s-4.08,1.49-4.24,2.08l0,3.07h-2.4v-3.12
			c0-2.24,3.8-4.42,6.64-4.42s6.64,2.19,6.64,4.42V44.55z"
                    />
                    <path
                        className={styles.cls1}
                        d="M36.06,39.41c-2.62,0-4.83-2.04-4.83-4.46v-1.63c0-2.42,2.21-4.46,4.83-4.46c2.61,0,4.82,2.04,4.82,4.46v1.63
			C40.88,37.37,38.67,39.41,36.06,39.41z M36.06,31.25c-1.27,0-2.43,0.98-2.43,2.06v1.63c0,1.08,1.16,2.06,2.43,2.06
			c1.27,0,2.42-0.98,2.42-2.06v-1.63C38.48,32.24,37.33,31.25,36.06,31.25z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default GetStartedConnect;
